import * as React from "react"

import { cn } from "@/lib/utils"

// يتمدد مع طول النص (الحد الأدنى من rows/min-h، والحد الأقصى 70% من ارتفاع الشاشة ثم يظهر تمرير داخلي)
const fit = (el) => {
  if (!el) return
  el.style.height = "auto"
  const h = el.scrollHeight
  if (h <= 0) return
  const max = Math.round((window.innerHeight || 800) * 0.7)
  el.style.height = `${Math.min(h, max)}px`
  el.style.overflowY = h > max ? "auto" : "hidden"
}

const Textarea = React.forwardRef(({ className, onInput, value, ...props }, ref) => {
  const inner = React.useRef(null)
  const setRef = (el) => {
    inner.current = el
    if (typeof ref === "function") ref(el)
    else if (ref) ref.current = el
  }
  React.useLayoutEffect(() => { fit(inner.current) }, [value])
  React.useEffect(() => {
    const el = inner.current
    if (!el || typeof ResizeObserver === "undefined") return
    const ro = new ResizeObserver(() => fit(el))
    ro.observe(el)
    return () => ro.disconnect()
  }, [])
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm resize-none",
        className
      )}
      ref={setRef}
      value={value}
      onInput={(e) => { fit(e.currentTarget); onInput?.(e) }}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
